export const APPLY_FAILURE_LOCATION_NOT_FOUND = "location_not_found";
export const APPLY_FAILURE_INSERT_FAILED = "insert_failed";
export const APPLY_FAILURE_BULK_MERGE_FAILED = "bulk_merge_failed";

export const APPLY_FAILURE_REASONS = [
  APPLY_FAILURE_LOCATION_NOT_FOUND,
  APPLY_FAILURE_INSERT_FAILED,
  APPLY_FAILURE_BULK_MERGE_FAILED,
] as const;

export type ApplyFailureReason = (typeof APPLY_FAILURE_REASONS)[number];

export type ActionOutcome = "applied" | "failed" | "dismissed" | "undismissed";

export function applyFailureReason(error: unknown): ApplyFailureReason {
  const tagged = (error as { reason?: string })?.reason;
  return APPLY_FAILURE_REASONS.find((reason) => reason === tagged) ?? APPLY_FAILURE_INSERT_FAILED;
}
